import { render, staticRenderFns } from "./OrderItems3.vue?vue&type=template&id=4eb6d261&"
import script from "./OrderItems3.vue?vue&type=script&lang=js&"
export * from "./OrderItems3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports